// extracted by mini-css-extract-plugin
export default {"center":"HeroShot_center__lXWi0","heroShotDimensions":"HeroShot_heroShotDimensions__X-TWb","heroShotStyle":"HeroShot_heroShotStyle__ZReQw"};